/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getAppTemplates = () => apiClient.get('/signature-templates');
export const getAppTemplateById = (id) => apiClient.get(`/signature-templates/${id}`);
export const getAppTemplateDomainById = (id) => apiClient.get(`/signature-templates/domain/${id}`);
export const getAppTemplateNameById = (id) => apiClient.get(`/signature-templates/template-name/${id}`);
export const getAppTemplatesAll = () => apiClient.get('/signature-templates/all');
export const getAppTemplateAllById = (id) => apiClient.get(`/signature-templates/all/${id}`);
export const updateAppTemplate = (id, data) => apiClient.put(`/signature-templates/${id}`, data);
export const deleteAppTemplate = (id) => apiClient.delete(`/signature-templates/${id}`);
export const deleteAppTemplateAll = (id) => apiClient.delete(`/signature-templates/all/${id}`);

export const createAppTemplate = async (data) => {
  try {
    const response = await apiClient.post('/signature-templates', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 409) {
          throw { type: 'duplicate', message: error.response.data?.error || 'El template ya existe.' };
      }
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error, por favor intente nuevamente.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};
